// src/theme.ts
export const theme = {
  colors: {
    black: '#000000',
    gray: '#808080',
    white: '#FFFFFF',
  },
};
